var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Studio-Final",
    transform: "translate(-360 -500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(151 478.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(25 17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M194.16-10.639a21.586,21.586,0,0,1-.24,3.451,10.055,10.055,0,0,1-.26,1.064,1.9,1.9,0,0,1-.81.905,2,2,0,0,1-.91.219,4,4,0,0,1-.95-.242l-.25-.094a22.281,22.281,0,0,1-5.89-4.024l-.09-.09-.38-.42a1.831,1.831,0,0,1-.38-1.138,1.778,1.778,0,0,1,.35-1.064,3.673,3.673,0,0,1,.28-.334l.38-.4a22.445,22.445,0,0,1,5.59-3.789A4.994,4.994,0,0,1,191.94-17H192a1.819,1.819,0,0,1,1.6.991,4.1,4.1,0,0,1,.24.784l.11.544a27.4,27.4,0,0,1,.21,3.688ZM202-11a1.507,1.507,0,0,1-1.5,1.517l-3.7-.327A1.186,1.186,0,0,1,195.62-11a1.186,1.186,0,0,1,1.18-1.191l3.7-.327A1.508,1.508,0,0,1,202-11Z",
    transform: "translate(386) rotate(180)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submitIcon.91905515b4f71aee6e97a6e9eb98e84d.svg";
export { ForwardRef as ReactComponent };